import { queryParams } from 'rise-ui/utils/link-to.js';

export function totalPages(totalItems, itemsPerPage) {
  return itemsPerPage ? Math.ceil((totalItems || 1) / itemsPerPage) : 1;
}

export function clampPage(page, pages) {
  if (pages) {
    page = Math.min(page, pages);
  }
  return Math.max(1, page);
}

export function pageLinks(key, page, pages) {
  page = page || 1;
  return {
    first:    pageLink(key),
    previous: pageLink(key, +page - 1, pages),
    next:     pageLink(key, +page + 1, pages),
    last:     pageLink(key, pages, pages),
  };
}

export function pageLink(key, page, pages) {
  if (page || page === 0) {
    page = clampPage(page, pages);
  }
  return queryParams({
    [key]: page !== 1 ? page : null,
  });
}
